module.exports = __webpack_public_path__ + "ship_holding_yacht_375x469.2bd4f73.jpg";